import { render, staticRenderFns } from "./IndividualTaxReturns.vue?vue&type=template&id=673110f4&"
import script from "./IndividualTaxReturns.vue?vue&type=script&lang=ts&"
export * from "./IndividualTaxReturns.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports